import {useState, useEffect} from 'react'
import {Field} from 'formik'
import {useIntl} from 'react-intl'
import { getOfferFilters } from '../../core/_requests'
import { OfferFilters } from '../../core/_models'
import {
  CustomSelect
} from '@/components/form'

const initialFilters = {
  country: '',
  type: '',
  enabled: 'true'
}

const FilterForm = () => {
  const intl = useIntl()
  const [config, setConfig] = useState<OfferFilters>({ countries: [], types: [] })
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const load = async () => {
    const res = await getOfferFilters()

    if (res) {
      setConfig(res)
    }
    setIsLoading(false)
  };

  useEffect(() => {
    if (isLoading) {
      load()
    }
  }, [isLoading])

  return (
    <>
      <Field
        default={intl.formatMessage({id: 'P2C.PAYMENT.PRICING.LIST.FILTER_FORM.COUNTRY_DEFAULT'})}
        component={CustomSelect}
        label={intl.formatMessage({id: 'P2C.PAYMENT.PRICING.FILTER_FORM.COUNTRY_LABEL'})}
        name="country"
        options={config.countries.map((t:string) => {
          return { value: t, label: t }
        })}
      />

      <Field
        default={intl.formatMessage({id: 'P2C.PAYMENT.PRICING.LIST.FILTER_FORM.PAY_MODE_DEFAULT'})}
        component={CustomSelect}
        label={intl.formatMessage({id: 'P2C.PAYMENT.PRICING.FILTER_FORM.PAY_MODE_LABEL'})}
        name="type"
        options={config.types.map((t:any) => {
          return { value: t.type, label: t.label }
        })}
      />

      <Field
        default={intl.formatMessage({id: 'P2C.PAYMENT.PRICING.LIST.FILTER_FORM.ENABLED_DEFAULT'})}
        component={CustomSelect}
        label={intl.formatMessage({id: 'P2C.PAYMENT.PRICING.LIST.FILTER_FORM.ENABLED_LABEL'})}
        name="enabled"
        options={[
          { value: 'true', label: 'Yes' }, 
          { value: 'false', label: 'No' }, 
        ]}
      />


    </>
  )
}

export {FilterForm, initialFilters}
